// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import {Panel} from '../../../comp/panel';
import {Usage_chart} from '../../../features/usage_chart';
import {Devices_table} from '../../../features/devices_table';
import * as cns from './income.module.less';

export function Income(){
    return <div className={cns.row}>
      <Panel><Devices_table/></Panel>
      <Panel className={cns.chart}><Usage_chart/></Panel>
    </div>;
}
